import Vue from 'vue'
import VueRouter from 'vue-router'
import Start from '../views/Start.vue'
import Formular from '../views/Formular.vue'
import DrinkView from "../views/DrinkView";
import FoodView from "../views/FoodView";
import EquipmentView from "../views/EquipmentView";


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Start',
    component: Start
  },
  {
    path: '/angebot-fordern',
    name: 'Angebot',
    component: Formular
  },

  {
    path: '/getraenke',
    name: 'Getränke',
    component: DrinkView
  },

  {
    path: '/speisen',
    name: 'Speisen',
    component: FoodView
  },
  {
    path: '/ausstattung',
    name: 'Ausstattung',
    component: EquipmentView
  },
]

const router = new VueRouter({
  routes
})

export default router
